import { jsx as _jsx } from "react/jsx-runtime";
import { classes } from "../utils/classes";
export default function Ring({ active = false, className }) {
    return (_jsx("div", { className: classes("pointer-events-none absolute inset-0 ring-3 transition-shadow ring-inset", active
            ? "ring-highlight"
            : "ring-white/25 group-hover/button:ring-highlight group-focus/button:ring-highlight", !/\brounded-/.test(className || "") && "rounded-lg", className) }));
}
